import React, { useState, useEffect, useRef } from 'react';
import './MembresiasPage.css';
import Header from './Header';
import Footer from './Footer';
import { 
  membresiasData, 
  formatPrice
} from '../data/membresiasData';
import { 
  FaComments, 
  FaGlassCheers, 
  FaBuilding, 
  FaUsers, 
  FaChartLine, 
  FaGraduationCap,
  FaHandshake,
  FaBullhorn,
  FaRocket,
  FaGift,
  FaIdCard,
  FaBook,
  FaPen,
  FaCalendarAlt,
  FaFileAlt
} from 'react-icons/fa';

const MembresiasPage = () => {
  const [billingCycle, setBillingCycle] = useState('anual');
  const [fraseIndex, setFraseIndex] = useState(0);
  const [fraseAnim, setFraseAnim] = useState('slide-in');
  const fraseTimeout = useRef();

  const { billingCycles, membresias } = membresiasData;

  // Frases de marketing persuasivas
  const frasesMarketing = [
    'BENEFICIOS EXCLUSIVOS',
    'COMUNIDAD PREMIUM',
    'ACCESO VIP A EVENTOS'
  ];

  // Efecto para rotar las frases
  useEffect(() => {
    setFraseAnim('slide-in');
    fraseTimeout.current = setTimeout(() => {
      setFraseAnim('slide-out');
      setTimeout(() => {
        setFraseIndex(i => (i + 1) % frasesMarketing.length);
        setFraseAnim('slide-in');
      }, 500);
    }, 3000);
    return () => clearTimeout(fraseTimeout.current);
  }, [fraseIndex, frasesMarketing.length]);

  const handleSubscribe = (membresiaId) => {
    // Aquí iría la lógica de suscripción
    console.log(`Suscribirse a ${membresiaId}`);
  };

  return (
    <>
      <Header />
      <main className="membresias-page">
        <div className="membresias-hero">
          <div className="container">
            <div className="membresias-hero-content">
              <div className="membresias-hero-left">
                <h1 className="membresias-titulo">
                  MEMBRESIA <span className="membresias-titulo-gold">GOLD</span>
                </h1>
            <p 
              className={`membresias-subtitulo membresias-slider-frase ${fraseAnim}`}
            >
              {frasesMarketing[fraseIndex]}
            </p>
            <p 
              className="membresias-subtitulo"
                  dangerouslySetInnerHTML={{ __html: '<span class="destacado">Tu pase VIP para formar parte de una comunidad exclusiva de empresarios y emprendedores comprometidos con crecer juntos.</span>' }}
            />
              </div>
              <div className="membresias-hero-right">
                <img 
                  src="/images/membresia/Gold.png" 
                  alt="Gold Membership Logo" 
                  className="membresias-hero-image"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="membresias-content">
          <div className="container">
            {/* Selector de ciclo de facturación - Oculto si solo hay anual */}
            {billingCycles.length > 1 && (
            <div className="billing-selector">
              {billingCycles.map((cycle) => (
                <button
                  key={cycle.id}
                  className={`billing-option ${billingCycle === cycle.id ? 'active' : ''}`}
                  onClick={() => setBillingCycle(cycle.id)}
                >
                  <span className="billing-label">{cycle.label}</span>
                  {cycle.discount > 0 && (
                    <span className="billing-discount">{cycle.discountText}</span>
                  )}
                </button>
              ))}
            </div>
            )}

            {/* Grid de membresías */}
            <div className="membresias-grid">
              {membresias.map((membresia) => (
                <div 
                  key={membresia.id} 
                  className={`membresia-card ${membresia.popular ? 'popular' : ''}`}
                >
                  <div className="membresia-header">
                    <h3 className={`membresia-nombre${membresia.id === 'gold' ? ' gold-glow' : ''}`}>
                      {membresia.id === 'gold' ? (
                        <><span className="membresia-nombre-gold">MEMBRESIA</span> <span className="membresia-nombre-gold">GOLD</span></>
                      ) : (
                        membresia.nombre
                      )}
                    </h3>
                    <div className="membresia-precio">
                      {membresia.precios[billingCycle].descuento > 0 && (
                        <div className="precio-original">
                          <span className="precio-tachado">
                            {formatPrice(membresia.precios[billingCycle].precioOriginal)}
                          </span>
                        </div>
                      )}
                      <div className="precio-line">
                      <span className="precio-amount">
                        {formatPrice(membresia.precios[billingCycle].precioFinal)}
                      </span>
                        <span className="precio-periodo">/ {billingCycle.charAt(0).toUpperCase() + billingCycle.slice(1)}</span>
                      </div>
                    </div>
                  </div>

                  <button 
                    className="membresia-cta"
                    onClick={() => handleSubscribe(membresia.id)}
                  >
                    Suscribirse
                  </button>

                  <div className="membresia-features">
                    {membresia.features && Array.isArray(membresia.features) ? (
                      // Formato antiguo (array simple)
                      membresia.features.map((feature, index) => (
                      <div key={feature.id} className={`feature-item ${feature.destacado ? 'destacado' : ''}`}>
                        <svg 
                          className={`feature-icon ${feature.included ? 'included' : 'not-included'}`}
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path 
                              d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                              stroke="currentColor" 
                              strokeWidth="2" 
                              strokeLinecap="round" 
                              strokeLinejoin="round"
                            />
                          </svg>
                          <span className="feature-text">{feature.text}</span>
                        </div>
                      ))
                    ) : (
                      // Formato nuevo (3 columnas)
                      <div className="features-columns">
                        <div className="features-column">
                          {membresia.features.columna1 && membresia.features.columna1.map((feature) => (
                            <div key={feature.id} className="feature-item">
                              <svg 
                                className="feature-icon included"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path 
                                  d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                                  stroke="currentColor" 
                                  strokeWidth="2" 
                                  strokeLinecap="round" 
                                  strokeLinejoin="round"
                                />
                              </svg>
                              <span className="feature-text">{feature.text}</span>
                            </div>
                          ))}
                        </div>
                        <div className="features-column">
                          {membresia.features.columna2 && membresia.features.columna2.map((feature) => (
                            <div key={feature.id} className="feature-item">
                              <svg 
                                className="feature-icon included"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path 
                                  d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                                  stroke="currentColor" 
                                  strokeWidth="2" 
                                  strokeLinecap="round" 
                                  strokeLinejoin="round"
                                />
                              </svg>
                              <span className="feature-text">{feature.text}</span>
                            </div>
                          ))}
                        </div>
                        <div className="features-column">
                          {membresia.features.columna3 && membresia.features.columna3.map((feature) => (
                            <div key={feature.id} className="feature-item">
                              <svg 
                                className="feature-icon included"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path 
                            d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span className="feature-text">{feature.text}</span>
                      </div>
                    ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Sección de beneficios adicionales */}
            <div className="beneficios-section">
              <h2 className="beneficios-titulo">
                BENEFICIOS <span className="beneficios-titulo-exclusivos">EXCLUSIVOS</span>
              </h2>
              <p className="beneficios-subtitulo">
                Conecta con clientes potenciales y aliados estratégicos. Comparte experiencias con empresarios que enfrentan tus mismos retos. Incrementa la visibilidad de tu empresa y posiciona tu marca en la comunidad. Recibe mentoría de expertos, fortalece conexiones a nivel local y nacional, y aumenta tus probabilidades de recibir más prospectos y ventas con estrategias diseñadas para generar resultados.
              </p>
              <div className="beneficios-grid">
                <div className="beneficio-item">
                  <div className="beneficio-icon">
                    <FaUsers />
                  </div>
                  <h3>Networking Prioritario y VIP</h3>
                  <p>Lugares VIP en eventos, oportunidad de presentar tu empresa y acceso exclusivo a eventos privados y dinámicas especiales para socios GOLD</p>
                </div>
                <div className="beneficio-item">
                  <div className="beneficio-icon">
                    <FaBullhorn />
                  </div>
                  <h3>Visibilidad Premium</h3>
                  <p>Aparición destacada en directorio digital, difusión en redes sociales oficiales y relaciones públicas personalizadas para posicionar tu marca</p>
                </div>
                <div className="beneficio-item">
                  <div className="beneficio-icon">
                    <FaHandshake />
                  </div>
                  <h3>Conexiones Estratégicas</h3>
                  <p>Presentación directa con prospectos y aliados clave, fortalecimiento de conexiones a nivel local y nacional, y reporte de networking trimestral</p>
                </div>
                <div className="beneficio-item">
                  <div className="beneficio-icon">
                    <FaChartLine />
                  </div>
                  <h3>Crecimiento y Resultados</h3>
                  <p>Estrategias diseñadas para generar más prospectos y ventas, acceso a CRM privado por evento y medición de tu crecimiento y contactos generados</p>
                </div>
                <div className="beneficio-item">
                  <div className="beneficio-icon">
                    <FaGraduationCap />
                  </div>
                  <h3>Desarrollo y Conocimiento</h3>
                  <p>Master classes, talleres y dinámicas de networking mensuales, mentoria y asesoría de expertos en áreas clave para expandir tus conocimientos</p>
                </div>
                <div className="beneficio-item">
                  <div className="beneficio-icon">
                    <FaRocket />
                  </div>
                  <h3>Recursos Exclusivos</h3>
                  <p>2 Day pass semanales (4 mensuales) en espacios físicos de trabajo, convenio de vinculación y ambiente de apoyo impulsado por empresarios que comparten tu visión</p>
                </div>
              </div>
            </div>

            {/* Sección de Kit de Bienvenida */}
            <div className="welcome-kit-section">
              <h2 className="welcome-kit-titulo">
                <span className="welcome-kit-titulo-text">WELCOME</span> <span className="welcome-kit-titulo-gold">KIT</span>
              </h2>
              <p className="welcome-kit-subtitulo">
                Al unirte al club, recibirás un <span className="welcome-kit-highlight">kit de bienvenida</span> que incluye:
              </p>
              <div className="welcome-kit-content">
                <div className="welcome-kit-items">
                  <div className="welcome-kit-item">
                    <div className="welcome-kit-icon">
                      <FaIdCard />
                    </div>
                    <p className="welcome-kit-text">
                      <span className="welcome-kit-gold">Credencial de socio GOLD</span>
                    </p>
                  </div>
                  <div className="welcome-kit-item">
                    <div className="welcome-kit-icon">
                      <FaGift />
                    </div>
                    <p className="welcome-kit-text">
                      Material exclusivo del club: <span className="welcome-kit-gold">Agenda</span>, <span className="welcome-kit-gold">pluma</span>, <span className="welcome-kit-gold">guía de beneficios</span> y <span className="welcome-kit-gold">calendario de eventos</span>
                    </p>
                  </div>
                </div>
                <div className="welcome-kit-visual">
                  <img 
                    src="/images/membresia/Gold.png" 
                    alt="Credencial Gold"
                    className="welcome-kit-image"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default MembresiasPage; 